import initTabs from '../tabs/tabs';

initTabs('.js--services-tabs');
